/**
 * Middleware to redirect URLs
 */
export default defineNuxtRouteMiddleware(to => {
	const appConfig = useAppConfig();
	const lang = appConfig?.lang || 'hr';
	const promotionsRoot = lang === 'si' ? '/akcije-popusti' : lang === 'hr' ? '/promotions' : null;
	const isPromotionsChild = promotionsRoot && to.path.replace(/\/+$/, '').startsWith(`${promotionsRoot}/`);

	// Redirect 404 promotions pages to promotions listing
	if (isPromotionsChild && to.meta.template === 'Error404') {
		return navigateTo(`${promotionsRoot}/`, {
			replace: true,
			redirectCode: 301,
		});
	}

	if(lang == 'hr') {
		// redirect old magento signup url
		if(to.path == '/sso-register/') {
			return navigateTo('/korisnik/signup/', {
				replace: true,
				redirectCode: 301,
			});
		}
	}
	
	// Check if path contains any tel pattern: :tel:, :tel, tel:
	const telPattern = /(:tel:|:tel|tel:)/i;
	const match = to.path.match(telPattern);
	if (match) {
		const cleanPath = to.path.substring(0, match.index);
		if (to.path !== cleanPath) {
			return navigateTo(cleanPath, {
				replace: true,
				redirectCode: 301,
			});
		}
	}

	// Check if URL has mode=gallery parameter
	if (to.query.mode === 'gallery') {
		// Create a new path without the query parameters
		const path = to.path;

		// Return redirect to the clean URL
		return navigateTo(path, {
			replace: true,
			redirectCode: 301, // Permanent redirect for SEO
		});
	}
});
